<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="abb"><a id="page_ix"></a><strong>Abbreviations</strong></h2>
<table>
<tbody>
<tr>
<td valign="top">
<p class="abb1">AARP</p>
</td>
<td valign="top">
<p class="abb1">American Association of Retired Persons (AARP became the complete name of the association in 1999)</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">AIDS</p>
</td>
<td valign="top">
<p class="abb">acquired immune deficiency syndrome</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">AMA</p>
</td>
<td valign="top">
<p class="abb">American Medical Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">AMI</p>
</td>
<td valign="top">
<p class="abb">Advocates for Medical Information</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">ANA</p>
</td>
<td valign="top">
<p class="abb">American Nurses’ Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">APhA</p>
</td>
<td valign="top">
<p class="abb">American Pharmaceutical Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">BCH</p>
</td>
<td valign="top">
<p class="abb">Boston City Hospital</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">BTC</p>
</td>
<td valign="top">
<p class="abb">behind-the-counter</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">CDAPCA</p>
</td>
<td valign="top">
<p class="abb">Comprehensive Drug Abuse Prevention and Control Act</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">CDER</p>
</td>
<td valign="top">
<p class="abb">Center for Drug Evaluation and Research (of the FDA)</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">CRR</p>
</td>
<td valign="top">
<p class="abb">Center for Reproductive Rights</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">DAWN</p>
</td>
<td valign="top">
<p class="abb">Drug Abuse Warning Network</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">DEA</p>
</td>
<td valign="top">
<p class="abb">Drug Enforcement Administration</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">DES</p>
</td>
<td valign="top">
<p class="abb">diethylstilbestrol</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">DESI</p>
</td>
<td valign="top">
<p class="abb">Drug Efficacy Study and Implementation</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">EKG</p>
</td>
<td valign="top">
<p class="abb">electrocardiogram</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">FBN</p>
</td>
<td valign="top">
<p class="abb">Federal Bureau of Narcotics</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">FDA</p>
</td>
<td valign="top">
<p class="abb">Food and Drug Administration</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">FDCA</p>
</td>
<td valign="top">
<p class="abb">Federal Food, Drug, and Cosmetic Act</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">FWHC</p>
</td>
<td valign="top">
<p class="abb">Feminist Women’s Health Center</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">GAO</p>
</td>
<td valign="top">
<p class="abb">Government Accountability Office</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">GNP</p>
</td>
<td valign="top">
<p class="abb">Gross National Product</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">HEW</p>
</td>
<td valign="top">
<p class="abb">Health, Education, and Welfare, Department of</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">HIV</p>
</td>
<td valign="top">
<p class="abb">human immunodeficiency virus</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">HMO</p>
</td>
<td valign="top">
<p class="abb">Health Maintenance Organization</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">IMR</p>
</td>
<td valign="top">
<p class="abb">Institution for Motivational Research</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">IPS</p>
</td>
<td valign="top">
<p class="abb">interim policy statement</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb"><a id="page_x"></a>IUD</p>
</td>
<td valign="top">
<p class="abb">intrauterine device</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">IUPAC</p>
</td>
<td valign="top">
<p class="abb">International Union of Pure and Applied Chemistry</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">LSD</p>
</td>
<td valign="top">
<p class="abb">lysergic acid diethylamide</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NDTI</p>
</td>
<td valign="top">
<p class="abb">National Disease and Therapeutic Index</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NIDA</p>
</td>
<td valign="top">
<p class="abb">National Institute on Drug Abuse</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NPA</p>
</td>
<td valign="top">
<p class="abb">National Prescription Audit</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NPC</p>
</td>
<td valign="top">
<p class="abb">National Pharmaceutical Council</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NRC</p>
</td>
<td valign="top">
<p class="abb">National Research Council</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NRTA</p>
</td>
<td valign="top">
<p class="abb">National Retired Teachers Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">NWHN</p>
</td>
<td valign="top">
<p class="abb">National Women’s Health Network</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">OFP</p>
</td>
<td valign="top">
<p class="abb">Office of Family Planning</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">OTC</p>
</td>
<td valign="top">
<p class="abb">over-the-counter</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">PCS</p>
</td>
<td valign="top">
<p class="abb">Prescription Card Services</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb"><em>PDR</em></p>
</td>
<td valign="top">
<p class="abb"><em>Physicians’ Desk Reference</em></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">PMA</p>
</td>
<td valign="top">
<p class="abb">Pharmaceutical Manufacturers Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">PPI</p>
</td>
<td valign="top">
<p class="abb">patient package insert</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">PTA</p>
</td>
<td valign="top">
<p class="abb">Parent-Teacher Association</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">sNDA</p>
</td>
<td valign="top">
<p class="abb">Supplemental New Drug Application</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">STI</p>
</td>
<td valign="top">
<p class="abb">sexually transmitted infection</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">UCLA</p>
</td>
<td valign="top">
<p class="abb">University of California, Los Angeles</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">UCSF</p>
</td>
<td valign="top">
<p class="abb">University of California, San Francisco</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">USP</p>
</td>
<td valign="top">
<p class="abb">United States Pharmacopeia</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">WCC</p>
</td>
<td valign="top">
<p class="abb">Women’s Capital Corporation</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">WHCS</p>
</td>
<td valign="top">
<p class="abb">Women’s Health Care Specialist</p>
</td>
</tr>
<tr>
<td valign="top">
<p class="abb">WHO</p>
</td>
<td valign="top">
<p class="abb">World Health Organization</p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviation.vue?0daeeaf8